<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_BLNoStatistics')"
    :width="$selectByLang('420px', '420px', '420px', '520px', '520px', '520px')"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
    @close="closeHandler()"
  >
    <div
      class="app-main-inner-row row-grid"
      style="min-height:350px;align-items: center;padding-top: 10px"
    >
      <cargo-ag-grid
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :show-side-bar="false"
        :row-data="rowData"
        style="width:100%;height:350px;"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchStatsData()"
      />
    </div>

  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { queryMAWBStatistics } from '@/api/AirExport/mawbDetail'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'StatisticsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      innerVisible: this.visible,
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          width: 210,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemainingQuantity'),
          field: 'remainingQuantity',
          width: 210
        }
      ],
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false
      },
      loading: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.fetchStatsData()
      }
    }
  },
  methods: {
    fetchStatsData() {
      const loading = getLoading4Cxt(this)
      const branchId = this.$store.getters.currentOfficeId
      const data = {
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize
      }
      queryMAWBStatistics(data, { branchId: branchId }).then(res => {
        this.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
      }).finally(() => {
        loading.close()
      })
    },
    closeHandler() {
      this.innerVisible = false
      this.$emit('update:visible', false) // 同步更新父组件的 visible 属性
    }
  }
}
</script>

<style lang="scss">
</style>
